import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { message } from "antd";
import { MdEmail } from 'react-icons/md';
import DeliveryLayout from "../../components/Layout/DeliveriesLayout";
import { actionCreators as userActionCreators } from "../../data/user/actions";

const VerifyPage = () => {
  const { t } = useTranslation('verify');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const email = useSelector(state => state.user.clientInfo.email);
  const emailVerified = useSelector(state => state.user.clientInfo.email_verified);
  const isLoading = useSelector(state => state.user.isLoading);

  useEffect(() => {
    if (emailVerified) {
      navigate("/", { replace: true });
    } else {
      dispatch(userActionCreators.refreshSession());
    }
  }, []);

  useEffect(() => {
    if (emailVerified) {
      message.success("E-post verifierad!", 3).then(() => {
        navigate("/", { replace: true });
      });
    }
  }, [emailVerified, navigate]);

  const handleRefreshSession = () => {
    dispatch(userActionCreators.refreshSession());
  };

  return (
    <DeliveryLayout>
      <div className='verify__wrapper'>
        <div className='verify__contentWrapper'>
          <MdEmail className='verify__icon' />
          <h1 className='verify__title'>{t('title')}</h1>
          <p className='verify__description'>
            {t('description1')} ({email}) {t('description2')}
          </p>
          <button
            onClick={handleRefreshSession}
            className="verify__button btn btn--primary"
            disabled={emailVerified || isLoading}
          >
            {emailVerified ? t('button.success') : t('button.fail')}
          </button>
        </div>
      </div>
    </DeliveryLayout>
  );
};

export default VerifyPage;
